import React, { useEffect, useState } from "react";
import "./MuffinAmount.css";
import { useSelector } from "react-redux";

import {
  getMuffinAmount,
  getOrganisationDashboard,
  getProviderByOrgName,
} from "../../../config/LiveApi";

function MuffinAmount() {
  const token = useSelector(
    (state) => state.userReducer.token
  );

  const [selectedDate, setSelectedDate] =
    useState(
      new Date()
        .toISOString()
        .split("T")[0]
    );

  const [selectedOrg, setSelectedOrg] =
    useState("");

  const [selectedPg, setSelectedPg] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  // ORGS

  const [orgOptions, setOrgOptions] =
    useState([]);

  // PROVIDERS

  const [pgOptions, setPgOptions] =
    useState([]);

  // CARDS

  const [cards, setCards] = useState([
    {
      slot: "12 AM - 8 AM",
      totalAmount: 0,
      totalTransactions: 0,
    },
    {
      slot: "8 AM - 11 AM",
      totalAmount: 0,
      totalTransactions: 0,
    },
    {
      slot: "11 AM - 2 PM",
      totalAmount: 0,
      totalTransactions: 0,
    },
    {
      slot: "2 PM - 5 PM",
      totalAmount: 0,
      totalTransactions: 0,
    },
    {
      slot: "5 PM - 12 AM",
      totalAmount: 0,
      totalTransactions: 0,
    },
  ]);

  // ================= FETCH ORGANISATIONS =================

  const fetchOrganisations = async () => {
    try {
      const response =
        await getOrganisationDashboard(
          token
        );

      if (
        response?.success &&
        response?.data
      ) {
        setOrgOptions(response.data);

        if (
          response.data.length > 0
        ) {
          setSelectedOrg(
            response.data[0].orgName
          );
        }
      }
    } catch (error) {
      console.log(
        "ORG FETCH ERROR :",
        error
      );
    }
  };

  // ================= FETCH PROVIDERS =================

  const fetchProviders = async (
    orgName
  ) => {
    try {
      const response =
        await getProviderByOrgName(
          orgName
        );

      if (
        response?.success &&
        response?.data
      ) {
        // ONLY PAYIN PROVIDERS

        const payinProviders =
          response.data.filter(
            (item) =>
              item.type === "payin"
          );

        setPgOptions(payinProviders);

        if (
          payinProviders.length > 0
        ) {
          setSelectedPg(
            payinProviders[0]
              .providerName
          );
        } else {
          setSelectedPg("");
        }
      }
    } catch (error) {
      console.log(
        "PROVIDER FETCH ERROR :",
        error
      );
    }
  };

  // ================= FETCH MUFFIN DATA =================

  const fetchMuffinAmount =
    async (
      date,
      orgName,
      pg
    ) => {
      try {
        setLoading(true);

        const payload = {
          orgName,
          pg,
          date,
        };

        const response =
          await getMuffinAmount(
            payload
          );

        if (
          response?.status &&
          response?.data
        ) {
          setCards(response.data);
        }
      } catch (error) {
        console.log(
          "MUFFIN FETCH ERROR :",
          error
        );
      } finally {
        setLoading(false);
      }
    };

  // ================= INITIAL LOAD =================

  useEffect(() => {
    if (token) {
      fetchOrganisations();
    }
  }, [token]);

  // ================= FETCH PROVIDERS WHEN ORG CHANGES =================

  useEffect(() => {
    if (selectedOrg) {
      fetchProviders(
        selectedOrg
      );
    }
  }, [selectedOrg]);

  // ================= FETCH DATA =================

  useEffect(() => {
    if (
      selectedDate &&
      selectedOrg &&
      selectedPg
    ) {
      fetchMuffinAmount(
        selectedDate,
        selectedOrg,
        selectedPg
      );
    }
  }, [
    selectedDate,
    selectedOrg,
    selectedPg,
  ]);

  // ================= HANDLERS =================

  const handleDateChange = (
    e
  ) => {
    setSelectedDate(
      e.target.value
    );
  };

  const handleOrgChange = (
    e
  ) => {
    setSelectedOrg(
      e.target.value
    );
  };

  const handlePgChange = (
    e
  ) => {
    setSelectedPg(
      e.target.value
    );
  };

  return (
    <div className="muffin-page">

      {/* ================= TOPBAR ================= */}

      <div className="muffin-topbar">

        <div>
          <h1 className="muffin-title">
            Muffin Amount Dashboard
          </h1>

          <p className="muffin-subtitle">
            Slot wise transaction
            analytics
          </p>
        </div>

        {/* ================= FILTERS ================= */}

        <div className="filter-wrapper">

          {/* ORG */}

          <div className="select-box">

            <label className="select-label">
              Organisation
            </label>

            <select
              value={selectedOrg}
              onChange={
                handleOrgChange
              }
              className="custom-select"
            >
              {orgOptions.map(
                (
                  org,
                  index
                ) => (
                  <option
                    key={index}
                    value={
                      org.orgName
                    }
                  >
                    {
                      org.orgName
                    }
                  </option>
                )
              )}
            </select>

          </div>

          {/* PROVIDER */}

          <div className="select-box">

            <label className="select-label">
              Provider
            </label>

            <select
              value={selectedPg}
              onChange={
                handlePgChange
              }
              className="custom-select"
            >
              {pgOptions.map(
                (
                  provider,
                  index
                ) => (
                  <option
                    key={index}
                    value={
                      provider.providerName
                    }
                  >
                    {
                      provider.providerName
                    }
                  </option>
                )
              )}
            </select>

          </div>

          {/* DATE */}

          <div className="select-box">

            <label className="select-label">
              Select Date
            </label>

            <div className="calendar-wrapper">

              <input
                type="date"
                value={
                  selectedDate
                }
                onChange={
                  handleDateChange
                }
                className="calendar-input"
              />

            </div>

          </div>

        </div>

      </div>

      {/* ================= CARDS ================= */}

      <div className="muffin-grid">

        {cards.map(
          (item, index) => (
            <div
              className="muffin-card"
              key={index}
            >

              <div className="card-circle"></div>

              {/* SLOT */}

              <div className="slot-pill">
                {item.slot}
              </div>

              {/* AMOUNT */}

              <div className="amount-section">

                <p className="amount-text">
                  Total Amount
                </p>

                <h1 className="amount-number">
                  ₹{" "}
                  {Number(
                    item.totalAmount ||
                      0
                  ).toLocaleString()}
                </h1>

                {/* TXN */}

                <div className="transaction-row">

                  <span className="transaction-label">
                    Transactions
                  </span>

                  <span className="transaction-count">
                    {
                      item.totalTransactions
                    }
                  </span>

                </div>

              </div>

              {/* LOADING */}

              {loading && (
                <div className="loading-overlay">
                  Loading...
                </div>
              )}

            </div>
          )
        )}

      </div>
    </div>
  );
}

export default MuffinAmount;